<template>
	<div aria-live="assertive" class="z-50 fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
		<div class="w-full flex flex-col items-center space-y-4 sm:items-end">
			<transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
				<div v-if="open" class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
					<div class="p-4">
						<div class="flex items-start">
							<div class="flex-shrink-0">

								<!-- Warning sign -->
								<div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
									<svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
									</svg>
								</div>

							</div>
							<div class="ml-3 w-0 flex-1 pt-0.5 mb-4 font-googleBold">
								<p class="text-gray-900">{{  title }}</p>
								<p class="mt-1 text-sm text-gray-800 font-google">{{ description }}</p>

							</div>
							<div class="ml-4 flex-shrink-0 flex">
								<button @click="open = false" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
									<span class="sr-only">Close</span>
									<XIcon class="h-5 w-5" aria-hidden="true" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script setup>
import { XIcon } from '@heroicons/vue/solid'
import {defineProps, watchEffect, defineEmits} from "vue";

const emit = defineEmits(['close']);

const props = defineProps({
	open: {type: Boolean, default: false},
	title: String,
	description: String,
	type: {type: String, default: 'warning'}
})

watchEffect(() => {
	if (props.open) {
		// Set a timeout to emit the 'close' event after 10 seconds
		setTimeout(() => {
			emit('close');
		}, 10000);
	}
});
</script>